(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splide-slider-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collections-images-slider')) {
    class CollectionsImagesSlider extends HTMLElement {
      constructor() {
        super();
        this.initSlider();
      }

      initSlider() {
        const options = {
          perPage: 5,
          arrows: false,
          pagination: false,
          type: 'loop',
          drag: 'free',
          focus: 'center',
          gap: '1rem',
          breakpoints: {
            767: {
              perPage: 2
            },
          },
        };

        this.slider = new Splide(this, options);

        // Ако AutoScroll extension е наличен:
        if (window.splide && window.splide.Extensions) {
          this.slider.mount(window.splide.Extensions);
        } else {
          this.slider.mount();
        }
      }
    }

    customElements.define(
      'collections-images-slider',
      CollectionsImagesSlider,
    );
  }

  } catch(e) { console.error(e); }
})();
})();
